import { CheckCircle, Wrench, Rocket, Target, DollarSign, MapPin } from "lucide-react";

const timeline = [
  { icon: Wrench, label: "Built", desc: "Core product developed", status: "done" },
  { icon: CheckCircle, label: "Working", desc: "Full & partial records", status: "done" },
  { icon: Rocket, label: "Ready", desc: "NY rollout prepared", status: "active" },
];

const metrics = [
  { icon: CheckCircle, label: "Core product functional", desc: "Automates full Record on Appeal" },
  { icon: Target, label: "Clear target buyer", desc: "Law firms and their clients" },
  { icon: DollarSign, label: "Clear ROI", desc: "Time savings and reduced service costs" },
  { icon: MapPin, label: "Ready for deployment", desc: "Product ready for rollout in the New York State court system" },
];

export default function TractionSlide() {
  return (
    <div
      className="h-full w-full flex flex-col p-7 sm:p-10 lg:p-12"
      data-testid="slide-traction-content"
    >
      <span className="text-sm font-bold tracking-[0.2em] uppercase text-blue-600 mb-2 font-body">
        TRACTION / PROOF
      </span>
      <h1 className="font-heading text-2xl sm:text-3xl lg:text-4xl font-black tracking-tighter text-slate-900 mb-6 leading-tight">
        Working product, clear use case, ready to deploy
      </h1>

      <div className="grid grid-cols-1 md:flex md:items-center gap-2 md:gap-4 mb-6 md:mb-8">
        {timeline.map((step, i) => (
          <div key={i} className="contents">
            <div
              className={`md:flex-1 rounded-lg p-3 sm:p-4 flex items-center gap-3 border ${
                step.status === "active"
                  ? "bg-blue-50 border-blue-200"
                  : "bg-slate-50 border-slate-200"
              }`}
            >
              <step.icon
                className={`h-5 w-5 shrink-0 ${
                  step.status === "active" ? "text-blue-600" : "text-emerald-500"
                }`}
              />
              <div>
                <div className="text-sm font-bold text-slate-900 font-heading">
                  {step.label}
                </div>
                <div className="text-[11px] sm:text-xs text-slate-500 font-body">
                  {step.desc}
                </div>
              </div>
            </div>
            {i < timeline.length - 1 && (
              <div className="hidden md:block w-6 sm:w-8 h-px bg-slate-300 shrink-0" />
            )}
          </div>
        ))}
      </div>

      <div className="flex-1 grid grid-cols-2 gap-3 sm:gap-4 min-h-0">
        {metrics.map((m, i) => (
          <div
            key={i}
            className="flex items-start gap-3 bg-white rounded-lg p-3 sm:p-4 border border-slate-100"
          >
            <m.icon className="h-4 w-4 text-blue-600 mt-0.5 shrink-0" />
            <div>
              <div className="text-sm font-semibold text-slate-900 font-heading">
                {m.label}
              </div>
              <div className="text-sm text-slate-500 font-body mt-0.5">
                {m.desc}
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
